import { Directive, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AnalyticsService, LanguageService } from '@dch/ng-common';
import { combineLatest } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { BillingCustomerService } from '../services/billing-customer.service';

@Directive({
  selector: '[myBillAnalyticsNavigation]',
  standalone: false,
})
export class MyBillAnalyticsNavigationDirective implements OnInit {
  constructor(
    private router: Router,
    private analyticsService: AnalyticsService,
    private customerService: BillingCustomerService,
    private route: ActivatedRoute,
    private languageService: LanguageService
  ) {}

  public ngOnInit() {
    const navigationEnd$ = this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    );

    combineLatest([this.customerService.getCustomerAccount(), navigationEnd$])
      .pipe(
        tap(([customerAccount, event]) => {
          if (customerAccount && event instanceof NavigationEnd) {
            const snapshot = this.route.snapshot;
            const routeData = snapshot.firstChild.data;
            if (routeData && routeData.analytics) {
              this.analyticsService.reportEvent(
                this.analyticsService.getAnalyticsEventData(
                  routeData.analytics,
                  this.languageService.getSelectedLanguage(),
                  customerAccount,
                  snapshot.queryParams
                )
              );
            }
          }
        })
      )
      .subscribe();
  }
}
